import type { QualifiedId as EngineQualifiedId } from "@imi-ernd-be/hyselect-engine";
import { QualifiedId } from "../products/types";

export function asQualifiedId({
  id,
  productSetId,
  type,
}: EngineQualifiedId): QualifiedId {
  return { id, productSetId, type };
}
